import type { Mouvement } from '@mairistem/comptabilite';
import { UserRole } from '@mairistem/finances-utils';
import BordereauStateStep from '../../../constants/liquidation/bordereaux/BordereauStateStep';
import BordereauStateType from '../../../constants/liquidation/bordereaux/BordereauStateType';
import BordereauActionType from '../../../interfaces/pieces/bordereaux/BordereauActionType';
import type MouvementActionType from '../../../interfaces/pieces/mouvements/liquidation/MouvementActionType';
import { BordereauWithState } from '../../../interfaces/pieces/TreeRow';
import type BaseLiquidationAction from '../../pieces/BaseLiquidationAction';
import BordereauDenumeroterAction from '../actions/BordereauDenumeroterAction';
import BordereauModifierAction from '../actions/BordereauModifierAction';
import BaseBordereauState from './BaseBordereauState';
import BordereauDupliquerAction from '../actions/BordereauDupliquerAction';
import MouvementModifierAction from '../../mouvements/liquidation/actions/MouvementModifierAction';
import MouvementDupliquerAction from '../../mouvements/liquidation/actions/MouvementDupliquerAction';
import BordereauRelancerFluxAction from '../actions/BordereauRelancerFluxAction';
import BordereauRejeterCollectiviteAction from '../actions/BordereauRejeterCollectiviteAction';

class BordereauEnEchecState extends BaseBordereauState {
  constructor() {
    super();
    this.step = BordereauStateStep.EN_ECHEC;
    this.state = BordereauStateType.EN_ECHEC;
    this.color = '#CF0000';
    this.libelle = 'En échec';
  }

  getBordereauActions(
    _bordereau: BordereauWithState,
    userRole: UserRole,
  ): BaseLiquidationAction<BordereauWithState, BordereauActionType>[] {
    return [
      new BordereauRelancerFluxAction({ isActionPrincipale: true }),
      new BordereauDupliquerAction(),
      new BordereauRejeterCollectiviteAction(),
      ...(userRole === UserRole.ADMIN) ? [
        new BordereauModifierAction({ isSuperUser: true }),
        new BordereauDenumeroterAction({ isSuperUser: true }),
      ] : [],
    ];
  }

  getMouvementActions(userRole : UserRole): BaseLiquidationAction<Mouvement, MouvementActionType>[] {
    return [
      new MouvementModifierAction({ isReadonly: true }),
      new MouvementDupliquerAction(),
      ...(userRole === UserRole.ADMIN) ? [
        new MouvementModifierAction({ isSuperUser: true }),
      ] : [],
    ];
  }
}

export default BordereauEnEchecState;
